import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { Data, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { ConfirmDeleteDialogComponent } from 'src/app/modal/confirm-delete/confirm-delete-dialog.component';
import { ConfirmUpdateDialogComponent } from 'src/app/modal/confirmar-update/confirm-update-dialog/confirm-update-dialog.component';
import { Procedimiento } from 'src/app/model/procedimiento';
import { environment } from 'src/environments/environment';
import { ProcedimientosService } from '../../_services/procedimientos.service';

@Component({
  selector: 'app-listado-procedimientos',
  templateUrl: './listado-procedimientos.component.html',
  styleUrls: ['./listado-procedimientos.component.css']
})
export class ListadoProcedimientosComponent extends UnsubscribeOnDestroy implements OnInit {
  displayedColumns: string[] = ['departamento.nombre', 'nombre', 'visible', 'acciones'];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  get totalProcedimientos(): number { return this.dataSource?.data?.length || 0; }
  get procedimientosMostrados(): number { return this.dataSource?.filteredData?.length ?? this.totalProcedimientos; }
  constructor(
    private procedimientosService: ProcedimientosService,
    private router: Router,
    public dialog: MatDialog,
  ) {
    super();
    this.currentEnv = environment.environment;
  }

  formFechaCierre = new UntypedFormGroup({
    fecha: new UntypedFormControl(""),
    hora: new UntypedFormControl(""),
  })

  formFechaApertura = new UntypedFormGroup({
    fecha: new UntypedFormControl(""),
    hora: new UntypedFormControl(""),
  })

  ngOnInit(): void {

    this.getProcedimientos();
  }

  procedimientos: Array<any> = [];
  procedimientosVisibles: any = [];
  dataSource = new MatTableDataSource<Procedimiento>();
  currentEnv: string;


  async getProcedimientos() {
    await this.procedimientosService.getProcedimientos()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {

          this.procedimientos = data['Procedimiento'];
          this.procedimientos = this.procedimientos.filter(procedimiento => procedimiento.fechaBaja == null);
          this.dataSource = new MatTableDataSource(this.procedimientos)
          this.dataSource.paginator = this.paginator;
          this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'departamento.nombre': return item.departamento.nombre;
              default: return item[property];
            }
          }
          this.dataSource.sort = this.sort;
        },
        error: (err) => {
          //console.log(err);
        }
      });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  updateVisibility(id: number) {
    return this.procedimientosService.updateVisibilityProc(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
        },
        error: (err) => {
        }
      })
  }

  updateCierre(id: number) {
    const formData = new FormData();
    formData.append('fecha', `${this.formFechaCierre.value.fecha}T${this.formFechaCierre.value.hora}:00`);
    this.procedimientosService.updateCierreProc(id, formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.refresh();
        },
        error: (err) => {
          //console.log(err);
        }
      });
  }

  updateApertura(id: number) {
    const formData = new FormData();
    formData.append('fecha', `${this.formFechaApertura.value.fecha}T${this.formFechaApertura.value.hora}:00`);
    this.procedimientosService.updateAperturaProc(id, formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {

        },
        error: (err) => {

          //this.update = false;
        }
      });
  }

  openDeleteDialog(procedimiento: Procedimiento) {
    const ref = this.dialog.open(ConfirmDeleteDialogComponent, {
      data: {
        title: 'Eliminar procedimiento',
        message: `¿Seguro que quieres eliminar el procedimiento «${procedimiento.nombre}»? Esta acción no se puede deshacer.`,
        confirmLabel: 'Eliminar'
      },
      panelClass: 'gu-dialog-panel'
    });
    return ref.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((ok) => {
        if (!ok) return;
        this.borrarProcedimiento(procedimiento.id).then(() => {
          this.reloadToMenuOption();
        });
      });
  }

  async borrarProcedimiento(id: Number) {
    await firstValueFrom(this.procedimientosService.borrarProcedimiento(id)).then((data) => {

    });
  }


  openDialog(procedimiento: Procedimiento): void {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.autoFocus = true;
    dialogConfig.width = '25vw';
    dialogConfig.minWidth = '500px';
    dialogConfig.data = procedimiento
    const dialogRef = this.dialog.open(EditProcedimientosDialog, dialogConfig)

  }

  refresh() {
    this.procedimientosService.getProcedimientos()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: Procedimiento[]) => {
        this.dataSource.data = data;
      });
  }

  scrollTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  reloadToMenuOption() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.scrollTop();
    if (this.currentEnv == 'emvs') {
      this.router.navigate(['/perfil'], { queryParams: { action: 10 } });
    } else {
      this.router.navigate(['/admin'], { queryParams: { action: 10 } });
    }

  }
}
@Component({
  selector: "dialog-editProcedimiento-dialog",
  templateUrl: "./dialog-editProcedimientos-dialog.html",
  styleUrls: ['./dialog-editProcedimientos-dialog.css']
})
export class EditProcedimientosDialog extends UnsubscribeOnDestroy {

  constructor(public dialogRef: MatDialogRef<EditProcedimientosDialog>
    , @Inject(MAT_DIALOG_DATA) public procedimiento: any,
    private router: Router,
    public dialog: MatDialog,
    private procedimientosService: ProcedimientosService,
    private datePipe: DatePipe

  ) {
    super();
    this.currentEnv = environment.environment;
  }

  isVisible = this.procedimiento.visible;
  fechaAperturaIncompletaWarning: boolean = false;
  fechaCierreIncompletaWarning: boolean = false;
  formData: FormData;
  apertura: any = "";



  currentEnv: string;

  ngOnInit() {
  }

  formUpdate: UntypedFormGroup = new UntypedFormGroup({
    nombre: new UntypedFormControl(""),
    fechaApertura: new UntypedFormControl(this.apertura),
    horaApertura: new UntypedFormControl(""),
    fechaCierre: new UntypedFormControl(""),
    horaCierre: new UntypedFormControl(""),
  })
  onNoClick(): void {
    this.dialogRef.close();
  }

  updateApertura(id: number) {

  }
  updateCierre(id: number) {
  }

  updateVisibility(ob: MatCheckboxChange) {
    this.isVisible = ob.checked;
  }

  async openDialog(): Promise<Data> {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.autoFocus = true;
    dialogConfig.width = '25vw';
    dialogConfig.minWidth = '500px';
    dialogConfig.data = { titulo: "actualización" }

    this.formData = this.comprobarDatos()

    if (!this.fechaAperturaIncompletaWarning && !this.fechaCierreIncompletaWarning) {
      const dialogRef = this.dialog.open(ConfirmUpdateDialogComponent, dialogConfig);
      return dialogRef.afterClosed()
        .pipe(takeUntil(this.destroy$))
        .subscribe(result => {
          if (result.result == 'Confirmar') {
            this.updateProcedimiento(this.procedimiento.id)
          }
        })
    } else {
      return null;
    }

  }

  updateProcedimiento(id: Number) {
    if (!this.fechaAperturaIncompletaWarning && !this.fechaCierreIncompletaWarning) {
      this.procedimientosService.updateProcedimiento(id, this.formData)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data) => {
            this.reloadToMenuOption();
            this.onNoClick();
          },
          error: (err) => {
            //this.update = false;
          }
        });
    }
  }

  private comprobarDatos() {
    var datestr;
    const formData = new FormData();
    if (this.formUpdate.value.nombre != "") {
      formData.append('nombre', this.formUpdate.value.nombre);
    } else {
      formData.append('nombre', this.procedimiento.nombre);
    }

    this.comprobarFechaApertura(formData);

    this.comprobarFechaCierrre(formData);

    formData.append('visible', this.isVisible);
    return formData;
  }

  private comprobarFechaCierrre(formData: FormData) {
    var datestr;
    if (this.formUpdate.value.fechaCierre != "" && this.formUpdate.value.horaCierre != "") {
      formData.append('fechaCierre', `${this.formUpdate.value.fechaCierre}T${this.formUpdate.value.horaCierre}:00`);
      this.fechaCierreIncompletaWarning = false;
    } else if ((this.formUpdate.value.fechaCierre != "" && this.formUpdate.value.horaCierre == "") || (this.formUpdate.value.fechaCierre == "" && this.formUpdate.value.horaCierre != "")) {
      this.fechaCierreIncompletaWarning = true;
    } else if (this.procedimiento.fechaCierre) {

      datestr = this.procedimiento.fechaCierre[0] + '-' + (this.procedimiento.fechaCierre[1] < 10 ? '0' + this.procedimiento.fechaCierre[1] : this.procedimiento.fechaCierre[1]) + '-' + (this.procedimiento.fechaCierre[2] < 10 ? '0' + this.procedimiento.fechaCierre[2] : this.procedimiento.fechaCierre[2]) + 'T' + (this.procedimiento.fechaCierre[3] < 10 ? '0' + this.procedimiento.fechaCierre[3] : this.procedimiento.fechaCierre[3]) + ':' + (this.procedimiento.fechaCierre[4] < 10 ? '0' + this.procedimiento.fechaCierre[4] : this.procedimiento.fechaCierre[4]) + ':00';
      this.fechaCierreIncompletaWarning = false;
      formData.append('fechaCierre', `${datestr}`);
    } else {
      this.fechaCierreIncompletaWarning = false;
      formData.append('fechaCierre', '');
    }
  }
  private comprobarFechaApertura(formData: FormData) {
    var datestr;
    if (this.formUpdate.value.fechaApertura != "" && this.formUpdate.value.horaApertura != "") {
      formData.append('fechaApertura', `${this.formUpdate.value.fechaApertura}T${this.formUpdate.value.horaApertura}:00`);
      this.fechaAperturaIncompletaWarning = false;
    } else if ((this.formUpdate.value.fechaApertura != "" && this.formUpdate.value.horaApertura == "") || (this.formUpdate.value.fechaApertura == "" && this.formUpdate.value.horaApertura != "")) {
      this.fechaAperturaIncompletaWarning = true;
    } else if (this.procedimiento.fechaApertura) {
      datestr = this.procedimiento.fechaApertura[0] + '-' + (this.procedimiento.fechaApertura[1] < 10 ? '0' + this.procedimiento.fechaApertura[1] : this.procedimiento.fechaApertura[1]) + '-' + (this.procedimiento.fechaApertura[2] < 10 ? '0' + this.procedimiento.fechaApertura[2] : this.procedimiento.fechaApertura[2]) + 'T' + (this.procedimiento.fechaApertura[3] < 10 ? '0' + this.procedimiento.fechaApertura[3] : this.procedimiento.fechaApertura[3]) + ':' + (this.procedimiento.fechaApertura[4] < 10 ? '0' + this.procedimiento.fechaApertura[4] : this.procedimiento.fechaApertura[4]) + ':00';
      this.fechaAperturaIncompletaWarning = false;
      formData.append('fechaApertura', `${datestr}`);
    } else {
      this.fechaAperturaIncompletaWarning = false;
      formData.append('fechaApertura', '');
    }
  }

  formatDate(date) {
    const dateFormat = date;
    let month = '' + (dateFormat[1]);
    let day = '' + dateFormat[2];
    let year = dateFormat[0];
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [day, month, year].join('/');
  }

  scrollTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  reloadToMenuOption() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.scrollTop()
    if (this.currentEnv == 'emvs') {
      this.router.navigate(['/perfil'], { queryParams: { action: 17 } });
    } else {
      this.router.navigate(['/admin'], { queryParams: { action: 17 } });
    }

  }
}
